import { render, staticRenderFns } from "./FileDetail.vue?vue&type=template&id=d3a579b8&"
import script from "./FileDetail.vue?vue&type=script&lang=ts&"
export * from "./FileDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports